/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetInspectorAuditReportResponse } from '../models/get-inspector-audit-report-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateInspectorAuditReportRequest } from '../models/create-inspector-audit-report-request';
import { UpdateInspectorAuditReportRequest } from '../models/update-inspector-audit-report-request';
@Injectable({
  providedIn: 'root',
})
class InspectorAuditReportService extends __BaseService {
  static readonly InspectorAuditReportGetAllPath = '/InspectorAuditReport/GetAll';
  static readonly InspectorAuditReportGetByIdPath = '/InspectorAuditReport/GetById';
  static readonly InspectorAuditReportCreatePath = '/InspectorAuditReport/Create';
  static readonly InspectorAuditReportUpdatePath = '/InspectorAuditReport/Update';
  static readonly InspectorAuditReportDeletePath = '/InspectorAuditReport/Delete';
  static readonly InspectorAuditReportDeleteRangePath = '/InspectorAuditReport/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  InspectorAuditReportGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetInspectorAuditReportResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/InspectorAuditReport/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetInspectorAuditReportResponse>>;
      })
    );
  }  InspectorAuditReportGetAll(): __Observable<Array<GetInspectorAuditReportResponse>> {
    return this.InspectorAuditReportGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetInspectorAuditReportResponse>)
    );
  }

  /**
   * @param request undefined
   */
  InspectorAuditReportGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetInspectorAuditReportResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/InspectorAuditReport/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetInspectorAuditReportResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  InspectorAuditReportGetById(request: GetFormRequest): __Observable<GetInspectorAuditReportResponse> {
    return this.InspectorAuditReportGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetInspectorAuditReportResponse)
    );
  }

  /**
   * @param request undefined
   */
  InspectorAuditReportCreateResponse(request: CreateInspectorAuditReportRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/InspectorAuditReport/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  InspectorAuditReportCreate(request: CreateInspectorAuditReportRequest): __Observable<string> {
    return this.InspectorAuditReportCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  InspectorAuditReportUpdateResponse(request: UpdateInspectorAuditReportRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/InspectorAuditReport/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  InspectorAuditReportUpdate(request: UpdateInspectorAuditReportRequest): __Observable<Blob> {
    return this.InspectorAuditReportUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  InspectorAuditReportDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/InspectorAuditReport/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  InspectorAuditReportDelete(id?: string): __Observable<Blob> {
    return this.InspectorAuditReportDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  InspectorAuditReportDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/InspectorAuditReport/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  InspectorAuditReportDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.InspectorAuditReportDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module InspectorAuditReportService {
}

export { InspectorAuditReportService }
